module.exports = __webpack_public_path__ + "img/bd-javazon-2.756ed5d4.png";